const EmptyConsent = /* @__PURE__ */ new Set();
export {
  EmptyConsent
};
//# sourceMappingURL=types.js.map
